import React from 'react';
import Head from 'next/head';

import styles from './NotFound.module.scss';

const NotFound = () => {
    return (
        <div className={styles.NotFound}>
            <Head>
                <title>Page Not Found - Wedding Spot</title>
            </Head>
            <div className={styles.content}>
                <div className={styles.contentBorder}>
                    <div className={styles.contentInner}>
                        <h1 className={styles.header}>Not Found</h1>
                        <br />
                        <p>
                            The page you were looking for was not found. If you believe this message was in error please&nbsp;
                            <a href='mailto:support@wedding-spot.com'>let us know</a>.
                        </p>
                        <br />
                        <a href='/wedding-venues/' className='nx-button nx-button--primary'>
                            Find a venue
                        </a>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default NotFound;
